// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checkpoint-measure-unit-editor {
  display: block;
}
.fi-checkpoint-measure-unit-editor .mat-mdc-form-field {
  width: 100%;
  position: relative;
}
.fi-checkpoint-measure-unit-editor .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper.mat-mdc-form-field-bottom-align {
  position: absolute;
  bottom: -22px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/general-tab/measure-unit-editor/measure-unit-editor.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAAI;EACI,WAAA;EACA,kBAAA;AAER;AADQ;EACI,kBAAA;EACA,aAAA;AAGZ","sourcesContent":[".fi-checkpoint-measure-unit-editor {\r\n    display: block;\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n        position: relative;\r\n        .mat-mdc-form-field-subscript-wrapper.mat-mdc-form-field-bottom-align {\r\n            position: absolute;\r\n            bottom: -22px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
